import { render, staticRenderFns } from "./navigationSetting.vue?vue&type=template&id=34af3d97&scoped=true&"
import script from "./navigationSetting.vue?vue&type=script&lang=js&"
export * from "./navigationSetting.vue?vue&type=script&lang=js&"
import style0 from "./navigationSetting.vue?vue&type=style&index=0&id=34af3d97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34af3d97",
  null
  
)

export default component.exports